import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../auth.store';
import { OrganizationStore } from '../domain/organization/organization-store';

/**
 * Keeps the lead CRM unreachable for anyone who is not a super-admin (user ruling
 * 2026-09-07). RLS already refuses the rows, so this is the second lock, not the only one:
 * it stops a non-super-admin from reaching a page that would render nothing but errors.
 */
export const superAdminGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const orgStore = inject(OrganizationStore);

  await authStore.loadAuthState();
  await orgStore.settled();

  if (orgStore.isSuperAdmin()) return true;
  return router.createUrlTree(['/portal']);
};
